export const DEFAULT_TEXT_COLOR = '#2C2B44';
export const DEFAULT_ICON_VECTOR_BG_COLOR = '#EBFBF7';
export const DEFAULT_ICON_VECTOR_TICK_COLOR = '#19AD89';
